<template>
  <b-row class="job-referrals-questions">

    <b-col cols="12" md="4" class="contact bg-light">
      <div class="info">
        <img :src="`/static/images/avatars/main${contact.avatar || 1}.png`" class="contact-picture"/>
        <div class="contact-name"><b>{{contact.fullName}}</b></div>
        <div class="jobTitle grey">{{contact.latestEmployment.title}} at <b>{{contact.latestEmployment.companyName}}</b></div>
      </div>
    </b-col>

    <b-col cols="12" md="8" class="questions">

      <b-row class="form-group">
        <div class="small-black-title slider-label">
          <div class="slider-label-title">
            <b>How well do you know {{contact.fullName}}?</b>
          </div>
          <div class="text-success slider-label-value" v-if="form.howWellRating && form.howWellRating >= 70">
            Very Well
          </div>
          <div class="text-warning slider-label-value" v-if="form.howWellRating && (form.howWellRating >= 40 && form.howWellRating <= 60)">
            Average
          </div>
          <div class="text-danger slider-label-value" v-if="form.howWellRating && form.howWellRating <= 30">
            Not Well
          </div>
        </div>
        <slider name="howWellRange" v-model="form.howWellRating" size="sm" />
      </b-row>

      <b-row class="form-group">
        <label for="toggle">Have you worked together?</label>
        <toggle label-true="Yes" label-false="No" v-model="form.workedTogether" />
      </b-row>

      <b-row class="form-group">
        <div class="small-black-title slider-label">
          <div class="slider-label-title">
            <b>How suited for the role will they be?</b>
          </div>
          <div class="text-success slider-label-value" v-if="form.howSuitableRating && form.howSuitableRating >= 70">
            Very Well
          </div>
          <div class="text-warning slider-label-value" v-if="form.howSuitableRating && (form.howSuitableRating >= 40 && form.howSuitableRating <= 60)">
            Average
          </div>
          <div class="text-danger slider-label-value" v-if="form.howSuitableRating && form.howSuitableRating <= 30">
            Not Suited
          </div>
        </div>
        <slider name="howSuitedRange" v-model="form.howSuitableRating" size="sm" />
      </b-row>

      <b-row class="form-group">
        <label for="otherInfo">Anything else you think we should know?</label>
        <b-form-input type="text" placeholder="e.g They'd be a fantastic hire!" v-model="form.userMessage"/>
      </b-row>

    </b-col>

  </b-row>
</template>

<script>
import Toggle from '@/components/misc/toggle';
import Slider from '@/components/misc/slider';

export default {
  name: 'JobReferralsQuestions',
  props: {
    contact: {
      type: Object,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    Toggle,
    Slider,
  },
  data() {
    return {
      form: {
        howWellRating: this.value.hasOwnProperty('howWellRating') ? this.value.howWellRating : null,
        workedTogether: this.value.hasOwnProperty('workedTogether') ? this.value.workedTogether : null,
        howSuitableRating: this.value.hasOwnProperty('howSuitableRating') ? this.value.howSuitableRating : null,
        userMessage: this.value.hasOwnProperty('userMessage') ? this.value.userMessage : null,
      },
    };
  },
  watch: {
    form: {
      deep: true,
      handler(value) {
        value.howWellRating = parseInt(value.howWellRating, 10);
        value.howSuitableRating = parseInt(value.howSuitableRating, 10);
        this.$emit('input', value);
      },
    }
  }
};
</script>

<style lang="scss">
.job-referrals-questions {
  // border-width: 1px;
  // border-style: solid;
  // border-color: #dadada;

  img {
    margin-bottom: 0.75rem;
    width: 60px;
    height: 60px;
  }

  .row {
    padding: 1rem;
    padding-left: 2rem;
    padding-right: 2rem;
    &.form-group {
      padding: 0.25rem 2rem 0.25rem 2rem;
    }
  }

  .questions {
    margin-top: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/job-referrals/refer-questions.vue